import { useSnackbar } from 'notistack';
import { Typography, Box, Container } from '@mui/material';
import { styled } from '@mui/system';
import OsNftDesktopBackground from 'assets/images/homeBanner/os-nft-desktop-background.png';
import OsNftDesktopIcon from 'assets/images/homeBanner/os-nft-desktop-icon.png';
import OsNftMobileBackground from 'assets/images/homeBanner/os-nft-mobile-background.png';
import OsNftMobileIcon from 'assets/images/homeBanner/os-nft-mobile-icon.png';
import { useWeb3React } from '@web3-react/core';
import { useAppDispatch } from 'redux/hook';
import { openWalletModal } from 'redux/slices/wallet';
import ConnectWalletButton from '../ConnectWalletButton';
import { copyText } from 'utils/copyText';

const BannerContainer = styled(Container, {
  shouldForwardProp: prop => prop !== 'sx',
})(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: '32px',
  paddingBottom: '32px',
  backgroundSize: 'cover',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '0px',
    paddingBottom: '0px',
  },
}));

const BannerDetail = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  color: 'white',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
  },
}));

export default function Banner() {
  const { enqueueSnackbar } = useSnackbar();
  const { account, active } = useWeb3React();
  const dispatch = useAppDispatch();

  const handleOpenConnectWalletDialog = async () => {
    if (active) {
      await copyText(account || '');
      enqueueSnackbar('Copied');
    } else {
      dispatch(openWalletModal());
    }
  };

  return (
    <Box
      sx={{
        backgroundSize: 'cover',
        backgroundImage: { xs: `url(${OsNftMobileBackground})`, md: `url(${OsNftDesktopBackground})` },
      }}
    >
      <BannerContainer>
        <Box
          sx={{ display: { xs: 'block', md: 'none' }, width: '261px', mb: '32px' }}
          component="img"
          alt="os-nft-icon"
          src={OsNftMobileIcon}
        />
        <Box
          sx={{
            display: { xs: 'none', md: 'block' },
            width: '435px',
          }}
          component="img"
          alt="os-nft-icon"
          src={OsNftDesktopIcon}
        />
        <BannerDetail>
          <Typography variant="h3" sx={{ mb: { xs: '0px', md: '16px' } }}>
            Hello!
          </Typography>
          <Typography variant="h4" sx={{ mb: { xs: '0px', md: '16px' }, textAlign: { xs: 'center', md: 'left' } }}>
            The collection of the next generation
          </Typography>
          <Typography
            sx={{ fontSize: '1.25rem', fontWeight: 400, mb: '16px', textAlign: { xs: 'center', md: 'left' } }}
          >
            Be part of the world's largest NFT arts
          </Typography>
          <ConnectWalletButton id="btn_connectWallet_banner" onClick={handleOpenConnectWalletDialog} />
        </BannerDetail>
      </BannerContainer>
    </Box>
  );
}
